'use client';

import { useEffect, useCallback } from 'react';
import devtools from 'devtools-detector';

interface IDevToolsState {
  isOpen: boolean;
  orientation: 'vertical' | 'horizontal';
}

const DisableDevTools = () => {
  // Handle keyboard shortcuts
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    // Disable F12
    if (e.code === 'F12') {
      e.preventDefault();
      return false;
    }

    // Disable Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
    if (e.ctrlKey && e.shiftKey && (e.code === 'KeyI' || e.code === 'KeyJ')) {
      e.preventDefault();
      return false;
    }

    if (e.ctrlKey && e.code === 'KeyU') {
      e.preventDefault();
      return false;
    }
  }, []);

  // Handle right click
  const handleContextMenu = useCallback((e: MouseEvent) => {
    e.preventDefault();
  }, []);

  // Handle DevTools state change
  const handleDevToolsChange = useCallback((isOpen: boolean) => {
    if (isOpen) {
      // Clear the page content when DevTools is detected
      document.body.innerHTML = '';
    } else {
      // Refresh the page when DevTools is closed
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    
    // Initialize devtools detector
    devtools.addListener(handleDevToolsChange);
    devtools.launch();

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      devtools.removeListener(handleDevToolsChange);
    };
  }, [handleContextMenu, handleKeyDown, handleDevToolsChange]);

  return null;
};

export default DisableDevTools; 